<template>
  <footer class="fixed-bottom bg-body-tertiary">
    <ul class="nav justify-content-center border-bottom pb-3 mb-3" />
    <p class="text-center mb-0 text-body-secondary">
      &copy; 2025 Trinity | Vantiva
    </p>
    <p class="text-center text-body-secondary">
      V{{ version }}
      <template v-if="commit && commit !== 'unknown'">
        ({{ commit }})
      </template>
    </p>
  </footer>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import api from "@/api/client";

const version = ref("");
const commit = ref("");

onMounted(async () => {
  try {
    const { data } = await api.get("/version");
    version.value = data.version;
    commit.value = data.commit;
  } catch {
    // silent
  }
});
</script>
